import {
    Grid,
    IconButton,
    InputAdornment,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
} from "@mui/material";
import classes from "../MainConverter.module.css";
import BaseButton from "../../ui/BaseButton";

import DownloadIcon from "@mui/icons-material/Download";
import UploadIcon from "@mui/icons-material/Upload";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";

import { useGlobalContext } from "../../../context/GlobalContext";
import CustTextField from "../../ui/CustTextField";
import { useState } from "react";
import FiltersButtonDet from "./FiltersButtonDet";
import LightTooltip from "../../ui/LightTooltip";
import NoddokTableRowHeader from "../../ui/NoddokTableRowHeader";
import CustomDatePicker from "../../ui/CustomDatePicker";

import { NumericFormat } from "react-number-format";

import moment from "moment";

const DetailsTable = (props) => {
    const {
        handleClickDownload,
        internal,
        rowsDet,
        setRowsDet,
        rowsDetOG,
        setRowsDetOG,
        filters,
        setFilters,
        tableRef,
        filterByStatus,
        conversionData,
        amountExt,
        totalRevenue,
        totalEgress,
        hasDuplicateEntries,
        saveChanges,
        convChanges,
        dateFormat,
    } = props;

    const { t, todos } = useGlobalContext();
    const [searchValue, setSearchValue] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);

    const columns = [
        { name: "date", title: t("payment.date"), width: "20%" },
        { name: "descrip", title: t("payment.description") },
        { name: "ref", title: t("accounts.ref"), width: "17%" },
        { name: "amount", title: t("credits.amount"), align: "right", width: "17%" },
        { name: "actions", title: "", width: "5%" },
    ];

    const notValid =
        rowsDetOG.filter((item) => !item.date || (!item.description && !item.reference) || !item.amount).length > 0;
    const notValidInternal =
        rowsDetOG.filter((item) => !item.date || (!item.description && !item.reference) || !item.amount).length > 0 ||
        rowsDetOG.length !== parseFloat(amountExt[0]?.value) ||
        rowsDetOG.find(
            (item) =>
                !moment(item.date).isValid() ||
                moment(item.date).isBefore(moment(conversionData.initial_date).subtract(5, "days")) ||
                moment(item.date).isAfter(moment(conversionData.end_date).add(5, "days"))
        ) ||
        (hasDuplicateEntries(rowsDetOG) &&
            parseFloat(amountExt[4]?.value) !==
                parseFloat(((conversionData.initial_balance ?? 0) + totalRevenue + totalEgress).toFixed(2))) ||
        parseFloat(amountExt[2]?.value) !== totalRevenue ||
        parseFloat(amountExt[3]?.value) !== totalEgress ||
        (conversionData.calculated_initial_balance !== null &&
            parseFloat(amountExt[4]?.value) !==
                parseFloat(((conversionData.initial_balance ?? 0) + totalRevenue + totalEgress).toFixed(2)));

    const generateUniqueId = () => Date.now().toString(36) + Math.random().toString(36).substring(2, 9);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDeleteRow = (id) => {
        setRowsDet(rowsDet.filter((item) => item._id !== id));
        setRowsDetOG(rowsDetOG.filter((item) => item._id !== id));
    };

    const handleNewRow = () => {
        const newId = generateUniqueId();
        const newLine = {
            _id: newId,
            new: true,
            date: null,
            description: "",
            reference: "",
            amount: "",
        };

        setRowsDet([...rowsDet, newLine]);
        setRowsDetOG([...rowsDetOG, newLine]);
        setPage(Math.floor(rowsDet.length / rowsPerPage));
    };

    const handleChangeSearchValue = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchValue(event.target.value);
        setPage(0);

        if (!query) {
            setRowsDet(rowsDetOG);
        } else {
            // Filtrar filas basadas en cualquier campo
            const filterCases = rowsDetOG.filter((row) =>
                Object.values(row).some(
                    (value) => value !== null && value !== undefined && value.toString().toLowerCase().includes(query)
                )
            );
            setRowsDet(filterCases);
        }
    };

    const handleChange = (event, id) => {
        const newArr = rowsDet.map((item, i) => {
            if (item._id === id) {
                item[event.target.name] = event.target.value;
            }
            return item;
        });
        const newArrOG = rowsDetOG.map((item, i) => {
            if (item._id === id) {
                item[event.target.name] = event.target.value;
            }
            return item;
        });

        setRowsDet(newArr);
        setRowsDetOG(newArrOG);
    };

    const handleChangeAmount = (value, id) => {
        const newArr = rowsDet.map((item) => {
            if (item._id === id) {
                item.amount = value;
            }
            return item;
        });
        const newArrOG = rowsDetOG.map((item) => {
            if (item._id === id) {
                item.amount = value;
            }
            return item;
        });

        setRowsDet(newArr);
        setRowsDetOG(newArrOG);
    };

    const handleChangeDate = (event, id) => {
        const newArr = rowsDet.map((item) => {
            if (item._id === id) {
                item.date = event;
            }
            return item;
        });
        const newArrOG = rowsDetOG.map((item) => {
            if (item._id === id) {
                item.date = event;
            }
            return item;
        });

        setRowsDet(newArr);
        setRowsDetOG(newArrOG);
    };

    return (
        <Paper elevation={0} square className={classes.mainCard}>
            <Typography variant="h2" color="primary" pb={2}>
                {t("converter.detail")}
            </Typography>
            <Grid container spacing={2} justifyContent="space-between">
                <Grid item>
                    <Stack direction="row" spacing={2}>
                        {internal ? (
                            <BaseButton
                                disableElevation
                                startIcon={<UploadIcon />}
                                onClick={() => saveChanges(true)}
                                sizebutton="l"
                                disabled={notValidInternal}
                            >
                                {t("converter.publish")}
                            </BaseButton>
                        ) : (
                            <BaseButton
                                disableElevation
                                startIcon={<DownloadIcon />}
                                onClick={handleClickDownload}
                                sizebutton="l"
                                disabled={notValid || convChanges}
                            >
                                {t("payment.download")}
                            </BaseButton>
                        )}
                        <BaseButton
                            disableElevation
                            onClick={() => saveChanges(false)}
                            sizebutton="l"
                            disabled={!convChanges}
                            variantType="primaryOutlined"
                        >
                            {t("register.saveChanges")}
                        </BaseButton>
                    </Stack>
                </Grid>
                <Grid item>
                    <Stack direction="row" spacing={2}>
                        <FiltersButtonDet
                            setFilters={setFilters}
                            filters={filters}
                            setRowsDet={setRowsDet}
                            rowsDetOG={rowsDetOG}
                            filterByStatus={filterByStatus}
                            conversionData={conversionData}
                            setPage={setPage}
                        />
                        <CustTextField
                            id="input-with-icon-textfield"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            issearch="true"
                            hiddenLabel
                            placeholder={t("team.search")}
                            value={searchValue}
                            onChange={handleChangeSearchValue}
                        />
                    </Stack>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer ref={tableRef}>
                        <Table sx={{ minWidth: 650, "& td": { padding: "10px 14px" } }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((item) => (
                                        <TableCell
                                            key={item.name}
                                            align={item.align ?? "left"}
                                            style={{ width: item.width }}
                                        >
                                            {item.title}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(rowsPerPage > 0
                                    ? rowsDet.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    : rowsDet
                                ).map((val) => (
                                    <TableRow key={val._id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                        <TableCell>
                                            <CustomDatePicker
                                                format={dateFormat}
                                                isError={!val.date}
                                                issearch="true"
                                                onChange={(e) => handleChangeDate(e, val._id)}
                                                value={val.date}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <CustTextField
                                                error={!val.description && !val.reference}
                                                fullWidth
                                                hiddenLabel
                                                issearch="true"
                                                name="description"
                                                onChange={(e) => handleChange(e, val._id)}
                                                size="small"
                                                value={val.description}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <CustTextField
                                                error={!val.description && !val.reference}
                                                hiddenLabel
                                                issearch="true"
                                                name="reference"
                                                onChange={(e) => handleChange(e, val._id)}
                                                size="small"
                                                value={val.reference}
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <NumericFormat
                                                value={val.amount}
                                                customInput={CustTextField}
                                                thousandSeparator={todos.amountFormat === "en-US" ? "," : "."}
                                                decimalSeparator={todos.amountFormat === "en-US" ? "." : ","}
                                                decimalScale={2}
                                                fixedDecimalScale
                                                onValueChange={(values) => {
                                                    handleChangeAmount(values.floatValue, val._id);
                                                }}
                                                hiddenLabel
                                                error={!val.amount}
                                                size="small"
                                                issearch="true"
                                                sx={{
                                                    "& input": {
                                                        textAlign: "right",
                                                    },
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <LightTooltip title={t("miscellaneous.delete")}>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleDeleteRow(val._id)}
                                                    sx={{
                                                        color: "V030", // Color gris
                                                        "&:hover": {
                                                            color: "C100", // Cambia el color al hacer hover
                                                        },
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            </LightTooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableFooter>
                                <NoddokTableRowHeader>
                                    <TableCell>
                                        <BaseButton
                                            variantType="primaryOutlined"
                                            sx={{ justifyContent: "space-between" }}
                                            disableElevation
                                            startIcon={<AddIcon />}
                                            onClick={handleNewRow}
                                        >
                                            {t("converter.addRow")}
                                        </BaseButton>
                                    </TableCell>
                                    <TablePagination
                                        showFirstButton
                                        showLastButton
                                        rowsPerPageOptions={[10, 20, 30, { label: t("miscellaneous.all"), value: -1 }]}
                                        colSpan={12}
                                        count={rowsDet.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        labelRowsPerPage={t("dashboard.rowsPerPage")}
                                        labelDisplayedRows={(page) =>
                                            `${page.from}-${page.to === -1 ? page.count : page.to} ${t(
                                                "team.unlinkText2"
                                            )} ${page.count}`
                                        }
                                    />
                                </NoddokTableRowHeader>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default DetailsTable;
